(() => {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;
  const radios = [...form.querySelectorAll('input[name="id"][type="radio"], input[name="cp-size"]')];
  const add = form.querySelector('[data-pdp-add]');
  const prints = [...document.querySelectorAll('[data-sg]')];
  const sgLabel = document.querySelector('[data-sg-label]');
  const bar = document.querySelector('[data-pdp-sticky]');
  const meta = bar && bar.querySelector('[data-pdp-sticky-meta]');
  function sync() {
    const index = Math.max(0, radios.findIndex(r => r.checked));
    prints.forEach(p => p.classList.toggle('is-on', +p.dataset.sg === index));
    if (sgLabel && radios[index]) sgLabel.textContent = radios[index].dataset.label + '.';
    if (meta && radios[index]) meta.textContent = radios[index].dataset.label + ' · ' + radios[index].dataset.money;
  }
  radios.forEach(r => r.addEventListener('change', sync));
  sync();
  if (!bar || !add || !('IntersectionObserver' in window)) return;
  bar.hidden = false;
  document.body.classList.add('cp-has-sticky');
  new IntersectionObserver(entries => {
    const e = entries[0];
    bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(add);
  bar.querySelector('[data-pdp-sticky-add]').addEventListener('click', () => {
    if (add.disabled) return;
    if (form.requestSubmit) form.requestSubmit(add); else add.click();
  });
})();
(() => {
  // Gallery: thumbnails, arrows, keep the active thumbnail in sync with swipes.
  const g = document.querySelector('[data-gallery]');
  if (g) {
    const track = g.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const thumbs = [...g.querySelectorAll('[data-thumb]')];
    const prev = g.querySelector('[data-gallery-prev]');
    const next = g.querySelector('[data-gallery-next]');
    let cur = 0;
    const go = i => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth }); };
    const mark = () => {
      cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      thumbs.forEach((t, i) => { t.classList.toggle('is-on', i === cur); t.setAttribute('aria-selected', i === cur); });
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur === slides.length - 1;
    };
    thumbs.forEach((t, i) => t.addEventListener('click', e => { e.preventDefault(); go(i); }));
    prev && prev.addEventListener('click', () => go(cur - 1));
    next && next.addEventListener('click', () => go(cur + 1));
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', () => go(cur));
    mark();
  }
  // Delivery estimate: 4 to 7 UK working days from today.
  const eta = document.querySelector('[data-pdp-eta]');
  if (eta) {
    const hol = ['12-25', '12-26', '12-28', '01-01', '01-02'];
    const key = d => String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w < 6 && !hol.includes(key(d))) k++; } return d; };
    const D = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const f = (d, m) => D[d.getDay()] + ' ' + d.getDate() + (m ? ' ' + M[d.getMonth()] : '');
    const a = add(4), b = add(7);
    eta.textContent = 'Order today for delivery around ' + f(a, a.getMonth() !== b.getMonth()) + ' – ' + f(b, true);
  }
})();
(() => {
  // Load later gallery pictures only when the shopper gets near them.
  const track = document.querySelector('[data-gallery-track]');
  if (track) {
    const load = img => { if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; } if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; } };
    const slides = [...track.children];
    const near = () => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); slides.slice(i, i + 3).forEach(s => s.querySelectorAll('img[data-src]').forEach(load)); };
    track.addEventListener('scroll', near, { passive: true });
    document.querySelectorAll('[data-thumb]').forEach((t, i) => t.addEventListener('click', () => slides.slice(Math.max(0, i - 1), i + 2).forEach(s => s.querySelectorAll('img[data-src]').forEach(load))));
    const idle = window.requestIdleCallback || (f => setTimeout(f, 2500));
    window.addEventListener('load', () => idle(() => slides.forEach(s => s.querySelectorAll('img[data-src]').forEach(load))));
  }
  // Jump to the photo strip.
  const jump = document.querySelector('[data-jump-photos]');
  const life = document.getElementById('pdp-life');
  if (jump) {
    if (!life) jump.hidden = true;
    else jump.addEventListener('click', e => { e.preventDefault(); life.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }
  // Christmas order-by line, shown until 14 Dec.
  const xm = document.querySelector('[data-pdp-xmas]');
  if (xm) { const now = new Date(); if (now.getMonth() === 9 || now.getMonth() === 10 || (now.getMonth() === 11 && now.getDate() <= 14)) xm.hidden = false; }
})();
(() => {
  // Colour + size picker (products with a Colour option): the two choices pick one variant.
  const form = document.querySelector('[data-product-form]');
  const data = document.querySelector('[data-pdp-variants]');
  if (!form || !data) return;
  let vs = [];
  try { vs = JSON.parse(data.textContent); } catch (e) { return; }
  const idIn = form.querySelector('input[type="hidden"][name="id"]');
  const sizes = [...form.querySelectorAll('input[name="cp-size"]')];
  const cols = [...form.querySelectorAll('input[name="cp-colour"]')];
  const add = form.querySelector('[data-pdp-add]');
  const addLabel = form.querySelector('[data-pdp-add-label]');
  const price = document.querySelector('[data-pdp-price]');
  const sticky = document.querySelector('[data-pdp-sticky-add]');
  const art = document.querySelector('[data-pdp-art]');
  const thumb = document.querySelector('[data-pdp-art-thumb]');
  const track = document.querySelector('[data-gallery-track]');
  let lastImg = art ? art.getAttribute('src') : '';
  function pick() {
    const s = (sizes.find(r => r.checked) || sizes[0] || {}).value;
    const c = (cols.find(r => r.checked) || cols[0] || {}).value;
    const v = vs.find(x => x.size === s && x.colour === c) || vs.find(x => x.size === s) || vs[0];
    if (!v) return;
    idIn.value = v.id;
    idIn.dataset.price = v.price;
    if (price) price.textContent = v.money;
    if (add) add.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? 'Add to bag' : 'Currently unavailable';
    if (sticky) sticky.disabled = !v.available;
    sizes.forEach(r => { const m = vs.find(x => x.size === r.value && x.colour === c); const box = r.parentNode.querySelector('[data-size-money]'); if (m) { r.dataset.money = m.money; if (box) box.textContent = m.money; } });
    if (art && v.img && v.img !== lastImg) {
      art.src = v.img; if (v.srcset) art.srcset = v.srcset; lastImg = v.img;
      if (thumb && v.thumb) thumb.src = v.thumb;
      if (track && track.scrollLeft > 10) track.scrollTo({ left: 0 });
    }
    try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    idIn.dispatchEvent(new Event('change', { bubbles: true }));
  }
  sizes.concat(cols).forEach(r => r.addEventListener('change', pick));
  pick();
})();
